import { render, staticRenderFns } from "./show-header.vue?vue&type=template&id=36122bf4&scoped=true"
import script from "./show-header.vue?vue&type=script&lang=js"
export * from "./show-header.vue?vue&type=script&lang=js"
import style0 from "./show-header.vue?vue&type=style&index=0&id=36122bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36122bf4",
  null
  
)

export default component.exports